import Section from './Section';
import { StyledAddIcon } from './Section.styles';
export { StyledAddIcon };
export default Section;
